import { TextInput } from '@mantine/core';
import type { FC } from 'react';

interface ReportedByFieldProps {
    value: string;
    onChange: (value: string) => void;
}

/**
 * Who at the site reported these numbers, asked at the moment of writing.
 *
 * ASKED IN THE FORM, NOT ON THE PAGE. This used to be a banner across the top of the site
 * screen, which had two problems. It sat on every tab whether or not anything was being
 * written, and — worse — it was sticky: a name typed once silently labelled everything the
 * brand did afterwards, including the next day. The field exists precisely to separate "the
 * site said this" from "I typed what they told me", so a value that outlives the moment of
 * the claim quietly undermines the thing it is for.
 *
 * Only the brand sees it. A manufacturer writing in its own portal is already identified by
 * its login, so the prop pair that renders this is simply not passed there.
 */
const ReportedByField: FC<ReportedByFieldProps> = ({ value, onChange }) => (
    <TextInput
        label="Numbers reported by"
        description="Who at the site gave you these — recorded against every row you enter here"
        placeholder="Their name"
        value={value}
        onChange={(event) => onChange(event.currentTarget.value)}
        withAsterisk
        data-autofocus
    />
);

export default ReportedByField;
